import React, { CSSProperties } from 'react';
import ResponsivePaddingWrapper from '../../../component/responsive/responsivePaddingWrapper';
import {
  FontWeightType, HeadingLarge, HeadingSmall, LabelMedium,
} from '../../../component/Text';
import { useMobile } from '../../../hook/usePlatform';
import { lineColor } from '../../../util/colors';

const ProgramStep : React.FC = () => {
  const isMobile = useMobile();
  const border = isMobile ? '' : `solid 1px ${lineColor}`;

  return (
    <div
      style={{
        borderTop: border,
        paddingInline: isMobile ? 32 : 0,
        paddingBlock: isMobile ? 24 : 160,
      }}
    >
      <ResponsivePaddingWrapper
        desktopPadding="15vw"
        style={{ flexDirection: 'column', display: 'flex', alignItems: 'center' }}
      >
        <HeadingLarge fontWeight={FontWeightType.w800}>프로그램 진행 과정</HeadingLarge>
        <Step step="1" title="상담 및 프로필 설정" subTitle="전문 컨설턴트와의 심층 상담을 통해 고객의 니즈와 선호도 파악" />
        <Step step="2" title="맞춤형 매칭 및 소개" subTitle="AI 분석 및 컨설턴트 추천을 기반으로 적합한 파트너 제안" />
        <Step step="3" title="만남 및 피드백" subTitle="첫 만남 후 고객 피드백을 수집하여 다음 매칭에 반영" />
        <Step step="4" title="관계 코칭 및 지원" subTitle="관계 발전을 위한 전문적인 조언과 심리적 지원 제공" />
      </ResponsivePaddingWrapper>

    </div>
  );
};
interface StepType {
  title:string,
  subTitle:string,
  step:string,
  style?:CSSProperties
}
const Step:React.FC<StepType> = ({
  title = '', subTitle = '', step = '', style = {},
}) => {
  const isMobile = useMobile();
  return (
    <div style={{
      marginTop: isMobile ? 24 : 64, width: '100%', display: 'flex', ...style,
    }}
    >
      {isMobile ? null
        : (
          <HeadingSmall fontWeight={FontWeightType.w700} style={{ flex: 0.9 }}>
            {step}
            단계
          </HeadingSmall>
        )}
      <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
        <div>
          <HeadingSmall fontWeight={FontWeightType.w700}>{title}</HeadingSmall>
          <LabelMedium style={{ fontFamily: 'inter' }}>{subTitle}</LabelMedium>
        </div>
      </div>
      {isMobile ? null : <div style={{ flex: 0.3 }} />}
    </div>
  );
};

export default ProgramStep;
